export default __webpack_public_path__ + "static/media/img-15.ef979c3a.jpg";